import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { groupBy, isNullOrEmpty } from '../../../../utils/util';
import { Input, Card, Collapsible, ScannerCode } from '../../../../components/UI/ComponentsUI'

const ContainerItemsAviexp = (props) => {
    let container2 = props.container2;
    let container1 = props.container1;
    let filter = props.filter;

    const validateGroupedAviexp = (data, container1) => {
        let aviexp = data.containerItem?.map(f => f.aviexpPartNumber);

        var grouped = groupBy(aviexp, "idAviexp");
        var filterPartNumber = container1 ? filter.partNumber1 : filter.partNumber2;

        const dataFilter = [];

        if (!isNullOrEmpty(filterPartNumber)) {
            grouped.forEach(element => {
                var elementFilter = element.value.aviexpPartNumber;
                if (elementFilter.find(f => f.partNumber.includes(filterPartNumber))) {
                    dataFilter.push({
                        key: element.key,
                        value: element.value.aviexpPartNumber.filter((i) => i.partNumber.includes(filterPartNumber))
                    })
                }
            });

            return dataFilter;
        }


        return grouped;

    }

    const validateGroupedBai = (data, container1) => {
        var list = []
        data.value.forEach(element => {
            element.aviexpOrders.forEach(element1 => {
                const elementTeste = element;
                list.push({
                    partNumber: elementTeste,
                    ...element1,
                })

            });
        });

        var grouped = groupBy(list, "box");
        var filterPartNumber = container1 ? filter.partNumber1 : filter.partNumber2;

        const dataFilter = [];

        if (!isNullOrEmpty(filterPartNumber)) {
            grouped.forEach(element => {
                var elementFilter = element.value.aviexpPartNumber;
                if (elementFilter.find(f => f.partNumber.includes(filterPartNumber))) {
                    dataFilter.push({
                        key: element.key,
                        value: element.value.aviexpPartNumber.filter((i) => i.partNumber.includes(filterPartNumber))
                    })
                }
            });

            return dataFilter;
        }

        return grouped;
    }

    const transferBaiContainer = (data, containerPrimary) => {
        if (containerPrimary) {
            if (!container2?.id) {
                return
            }
            data.forEach(element => {
                const data1 = element.partNumber.containerItem

                data1.forEach(element => {
                    var itemadd = container1.containerItem.find(f => f.id === element.id);
                    if (itemadd) {
                        container2.containerItem.push(itemadd);
                        container1.containerItem = container1.containerItem.filter(f => f.id !== element.id);
                    }
                });

            });
        } else {
            data.forEach(element => {
                const data1 = element.partNumber.containerItem

                data1.forEach(element => {
                    var itemadd = container2.containerItem.find(f => f.id === element.id);
                    if (itemadd) {
                        container1.containerItem.push(itemadd);
                        container2.containerItem = container2.containerItem.filter(f => f.id !== element.id);
                    }
                });
            });
        }

        props.setContainer1({ ...container1 })
        props.setContainer2({ ...container2 })
    }

    const transferAviexpContainer = (data, containerPrimary) => {
        if (containerPrimary && !container2?.id) {
            return
        }

        data.forEach(element => {
            element.containerItem.forEach(containerItem => {
                const data1 = containerItem

                if (containerPrimary) {
                    var itemadd = container1.containerItem.find(f => f.id === data1.id);
                    if (itemadd) {
                        container2.containerItem.push(itemadd);
                        container1.containerItem = container1.containerItem.filter(f => f.id !== data1.id);
                    }
                } else {
                    var itemadda = container2.containerItem.find(f => f.id === data1.id);
                    if (itemadda) {
                        container1.containerItem.push(itemadda);
                        container2.containerItem = container2.containerItem.filter(f => f.id !== data1.id);
                    }
                }
            });
        });

        props.setContainer1({ ...container1 })
        props.setContainer2({ ...container2 })
    }

    return (
        <div className="row">
            <div className="col s12 m5">
                <Card>
                    <div id="getOrigem" className="row" style={{ padding: '10px' }}>
                        <div className="input-field no-padding col s12">
                            <Input
                                required
                                id="container1"
                                name='container1'
                                maxLength="11"
                                label="Num. Container"
                                type="text"
                                value={filter?.container1 || ''}
                                onBlur={() => props.searchContainer(true)}
                                onChange={props.onChange}
                            />
                        </div>
                        {
                            container1.id > 0 &&
                            <>
                                <div className="input-field no-padding col s6">
                                    <ScannerCode onScanner={(value) => {
                                        filter.partNumber1 = value;
                                        props.setFilter({ ...filter })
                                    }} />
                                    <Input
                                        id="partNumber1"
                                        name='partNumber1'
                                        maxLength="11"
                                        placeHolder="Partnumber"
                                        type="text"
                                        value={filter?.partNumber1 || ''}
                                        onChange={props.onChange}
                                    />
                                </div>
                                {
                                    container2?.id && <div className="input-field no-padding col s5" style={{ display: 'flex', justifyContent: 'flex-end' }}>

                                        <i style={{ cursor: 'pointer' }}
                                            onClick={() => transferAviexpContainer([container1], true)}

                                            className="mdi mdi-36px mdi-chevron-triple-right"></i>
                                    </div>
                                }

                            </>

                        }
                    </div>
                    {container1 && container1.containerItem && validateGroupedAviexp(container1, true).map((f, index) =>
                        <Collapsible
                            id={index}
                            actions={
                                [
                                    {
                                        func: () => transferAviexpContainer(f.value, true),
                                        actionicon: "mdi mdi-36px mdi-arrow-right-bold"
                                    }
                                ]
                            }
                            close={"true"}
                            header={`Aviexp ${f.key}`}
                            body={
                                validateGroupedBai(f).map((a, index) =>
                                    <Collapsible
                                        id={index}
                                        actions={
                                            [
                                                {
                                                    func: () => transferBaiContainer(a.value, true),
                                                    actionicon: "mdi mdi-36px mdi-arrow-right-bold"
                                                }
                                            ]
                                        }
                                        close={"true"}
                                        header={`Nº Caixa ${a.key}`}
                                        body={
                                            a.value.map(p => <fieldset className='fieldset'>
                                                <div>
                                                    Partnumber : {p.partNumber.partNumber}
                                                </div>
                                                <div>
                                                    Quantidade : {p.quantityBox}
                                                </div>
                                            </fieldset>

                                            )
                                        }
                                    />
                                )
                            }
                        />
                    )}
                </Card>
            </div>
            {
                container1.id > 0 &&
                <div className="col s12 m5">
                    <Card>
                        <div id="getOrigem" className="row" style={{ padding: '10px' }}>
                            <div className="input-field no-padding col s12">
                                <Input
                                    required
                                    id="container2"
                                    name='container2'
                                    maxLength="11"
                                    label="Num. Container"
                                    type="text"
                                    value={props.filter?.container2 || ''}
                                    onBlur={() => props.searchContainer(false)}
                                    onChange={props.onChange}
                                />
                            </div>
                            {
                                container2.id > 0 &&
                                <>
                                    <div className="input-field no-padding col s5" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                        <i style={{ cursor: 'pointer' }}
                                            onClick={() => transferAviexpContainer([container2], false)}
                                            className="mdi mdi-36px mdi-chevron-triple-left"></i>
                                    </div>
                                    <div className="input-field no-padding col s6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <ScannerCode onScanner={(value) => {
                                            filter.partNumber2 = value;
                                            props.setFilter({ ...filter })
                                        }} />
                                        <Input
                                            id="partNumber2"
                                            name='partNumber2'
                                            maxLength="11"
                                            placeHolder="Partnumber"
                                            type="text"
                                            value={filter?.partNumber2 || ''}
                                            onChange={props.onChange}
                                        />
                                    </div>

                                </>

                            }
                        </div>
                        {container2 && container2.containerItem && validateGroupedAviexp(container2, false).map((f, index) =>
                            <Collapsible
                                id={index}
                                actionPosition="left"
                                actions={
                                    [
                                        {
                                            func: () => transferAviexpContainer(f.value, false),
                                            actionicon: "mdi mdi-36px mdi-arrow-left-bold"
                                        }
                                    ]
                                }
                                close={"true"}
                                header={`Aviexp ${f.key}`}
                                body={
                                    validateGroupedBai(f).map((a, index) =>
                                        <Collapsible
                                            id={index}
                                            actionPosition="left"
                                            actions={
                                                [
                                                    {
                                                        func: () => transferBaiContainer(a.value, false),
                                                        actionicon: "mdi mdi-36px mdi-arrow-left-bold"
                                                    }
                                                ]
                                            }
                                            close={"true"}
                                            header={`Nº Caixa ${a.key}`}
                                            body={
                                                a.value.map(p => <fieldset className='fieldset'>
                                                    <div>
                                                        Partnumber : {p.partNumber.partNumber}
                                                    </div>
                                                    <div>
                                                        Quantidade : {p.quantityBox}
                                                    </div>
                                                </fieldset>

                                                )
                                            }
                                        />
                                    )
                                }
                            />
                        )}
                    </Card>

                </div>
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerItemsAviexp));